/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { formatMoneyPunto } from "utils/formatters";

const columns = [
    { name: "nombre", desc: "Producto", align: "left", width: "30%" },
    { name: "precio", desc: "Precio", align: "center", width: "15%" },
    { name: "cantidad", desc: "Cantidad", align: "center", width: "15%" },
    { name: "estado", desc: "Estado", align: "center", width: "15%" },
    { name: "acciones", desc: "Acciones", align: "center", width: "15%" }
];


const getRows = (data, openMenu) => {
    const rows = [];
    if (data && data.length > 0) {
        data.forEach((item) => {
            const { producto } = item;
            rows.push({
                nombre: (
                    <SoftBox >
                        <SoftTypography
                            verticalAlign="text-top"
                            variant="caption"
                            color="dark"
                            fontWeight="bold"
                        >
                            {producto?.nombre}
                        </SoftTypography>
                    </SoftBox>
                ),
                cantidad: (
                    <SoftBox >
                        <SoftTypography
                            verticalAlign="text-top"
                            variant="caption"
                            color="dark"
                            fontWeight="bold"
                        >
                            {item?.cantidad}
                        </SoftTypography>
                    </SoftBox>
                ),
                precio: (
                    <SoftBox display="flex" justifyContent="center" alignItems="center">
                        <SoftTypography
                            verticalAlign="text-top"
                            variant="caption"
                            color="dark"
                            fontWeight="bold"
                        >
                            {item?.precioEditado !== null ? item?.precioEditado == 0 ? 'Gratuito' :  '$' + formatMoneyPunto(item?.precioEditado) : '$' + formatMoneyPunto(producto?.precioCarta)}
                            {item?.precioEditado !== null && item?.precioEditado !== producto?.precioCarta && (
                                <SoftTypography
                                    verticalAlign="text-top"
                                    variant="caption"
                                    color="primary"
                                    fontWeight="bold"
                                >
                                    &nbsp;&nbsp;(Editado)
                                </SoftTypography>
                            )}
                        </SoftTypography>
                    </SoftBox>
                ),
                estado: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={item?.estado ? item?.estado : "N/A"}
                        color={
                            item?.estado === ""
                                ? "light"
                                : item?.estado === "PENDIENTE"
                                    ? "warning"
                                    : item?.estado === "ENTREGADO"
                                        ? "success"
                                        : item.estado === "CANCELADO"
                                            ? "error"
                                            : "light"
                        }
                        size="xs"
                        container
                    />
                ),
                acciones: (
                    <SoftBox
                        mr={2}
                        sx={{
                            cursor: "pointer",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            openMenu(e, item)
                        }
                        }
                    >
                        <Tooltip title="Opciones" placement="top">
                            <Icon
                                sx={{ color: "primary", cursor: "pointer", mx: 0.5 }}
                                fontSize="small"
                            >
                                more_vert
                            </Icon>
                        </Tooltip>
                    </SoftBox>
                )
            });
        });
    }

    return rows;
}

export default { columns, getRows };